import React from 'react';
import { createPortal } from 'react-dom';
import styled from '@xstyled/styled-components';
import { BurgerButtonEds } from '~/ui/buttons/BurgerButtonEds';
import { TrainingState, useTrainingStore } from '../state';
import { select } from '~/lib/select';
import { MediaPlayerStore } from '~/ui/video-player/MediaPlayerStore';
import { useMediaPlayerStore } from '~/ui/video-player/MediaPlayerProvider';

const Button = styled(BurgerButtonEds)`
  position: fixed;
  top: 20px;
  left: 8px;
  z-index: hud;
  @media ((max-width: 580px) and (max-height: 300px)) {
    left: 10px;
  }
`;

const selector = (s: TrainingState) =>
  select(s, 'toggleNav', 'activeItemPosition', 'open');

const mediaSelector = (s: MediaPlayerStore) => select(s, 'pause');

/** Shared id for Menu ↔ navigation dialog (aria-controls). */
export const COURSE_NAVIGATION_DIALOG_ID = 'course-navigation-dialog';

export const OpenNavigationButton = () => {
  const { toggleNav, activeItemPosition, open } = useTrainingStore(selector);
  const { pause } = useMediaPlayerStore(mediaSelector);

  const onClick = () => {
    try {
      pause();
    } catch (error) {
      // Silently ignore media player errors
    }
    toggleNav();
  };

  return createPortal(
    <Button
      onClick={onClick}
      tabIndex={0}
      aria-expanded={open}
      aria-controls={open ? COURSE_NAVIGATION_DIALOG_ID : undefined}
      aria-haspopup="dialog"
      data-test-id="training-navigation-burger-button"
    >
      {Math.floor(activeItemPosition / 10000)}
    </Button>,
    document.getElementById('root')!
  );
};
